import React, { useEffect } from "react";
import "./immpressumPage.scss";
export default function ImmpressumPage() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div>
      <div className="immpressum-page-all-content-alignment">
        <div className="container-xs">
          <div className="text-grid">
            <div className="text-grid-items">
              <h1>DEUTSCHER IMMOBILIEN DIENST GmbH</h1>
            </div>
            <div className="text-grid-items">
              <div className="divider"></div>
            </div>
          </div>
          <div className="first-content-style">
            <p>Teerhof 59</p>
            <p>28199 Bremen</p>
            <p>Gesetzlicher Vertreter und Geschäftsführer:</p>
          </div>
          <div className="first-content-style">
            <p>Sandra Sorgenfrei</p>
            <p>Jack Daniel Rausch</p>
          </div>
          <div className="first-content-style">
            <p>Handelsregister Amtsgericht Bremen HRB 15157 HB</p>
            <p>UmsatzsteuerID Nr.: DE 139 778 914</p>
            <p>Steuer Nr.: 60 110 10332</p>
          </div>
          <div className="first-content-style">
            <p>
              Gewerbeerlaubnis gemäß § 34c GewO, erteilt von der Stadt Bremen,
              Gewerbeamt
            </p>
          </div>
          <div className="first-content-style">
            <p>
              DEUTSCHER IMMOBILIEN DIENST GmbH ist Eigentümerin, der beim
              Deutschen Patent- und Markenamt registrierten Marken:
            </p>
            <p>
              DE 302012012171 Wiedergabe der Marke: DEUTSCHER IMMOBILIEN DIENST
            </p>
          </div>
          <div className="first-content-style">
            <p>Fon 0421 / 1 67 61 80-0</p>
            <p>Fax 0421 / 1 67 61 80-9</p>
          </div>
          <div className="first-content-style">
            <p>E-Mail: info@deutscher-immobilien-dienst.de</p>
          </div>
          <div className="first-content-style">
            <p>Inhaltlich Verantwortlicher gemäß § 55 Abs. 2 RStV:</p>
            <p>DEUTSCHER IMMOBILIEN DIENST GmbH (Anschrift wie oben)</p>
          </div>
          <div className="first-content-style">
            <p>Quellenangaben für die verwendeten Bilder und Grafiken:</p>
            <p>Quellenangaben für die verwendeten Bilder und Grafiken:</p>
          </div>
        </div>
      </div>
    </div>
  );
}
